const noop = function noop() {};

const handleMethod = (name, mixin, prototype) => {
    const m = mixin;

    const method = m[name];
    delete m[name];

    let descriptor = Object.getOwnPropertyDescriptor(prototype, name);

    if (descriptor) {
        const fn = descriptor.value;
        descriptor.value = function componentMixinMethod(...args) {
            const returnValue = method.call(this, ...args);
            if (returnValue && returnValue.then) {
                return returnValue.then(() => {
                    return fn.call(this, ...args);
                });
            } else {
                return fn.call(this, ...args);
            }
        };
    } else {
        descriptor = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: function componentMixinMethod(...args) {
                return method.call(this, ...args);
            },
        };
    }

    Object.defineProperty(prototype, name, descriptor);
};

const componentMixin = (mixin) => {
    const m = Object.assign({}, mixin);
    const { props } = m;
    delete m.props;

    const { options } = m;
    delete m.options;

    const preOnBeforeSetup = function componentMixinPreOnBeforeSetup() {
        if (props) {
            // clone props which are either objects or arrays

            Object.keys(props).forEach((key) => {
                const prop = props[key];
                if (typeof prop === 'object') props[key] = { ...prop };
                if (typeof prop === 'array') props[key] = [...prop];
            });
            this.props = Object.assign({}, props, this.props);
        }

        if (options) {
            this.options = Object.assign({}, options, this.options);
        }
    };

    const onBeforeSetup = m.onBeforeSetup || noop;
    m.onBeforeSetup = async function wrappedOnBeforeSetup(...args) {
        preOnBeforeSetup.call(this, ...args);
        await onBeforeSetup.call(this, ...args);
    };

    return (target) => {
        Object.keys(m).forEach((value) => {
            if (typeof m[value] === 'function') {
                handleMethod(value, m, target.prototype);
            }
        });
    };
};

export { componentMixin };
